import { render, staticRenderFns } from "./DueChargebacks.vue?vue&type=template&id=7c98ec44"
import script from "./DueChargebacks.vue?vue&type=script&lang=js"
export * from "./DueChargebacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DueChargebacks.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports